require('./bootstrap');

$(document).ready(function() {
    // $('.form-checkbox, .form-checkbox-label').click(function() {
    //     const checkbox = $(this).closest('.form-labeled-checkbox').find('input.form-checkbox')
    //     const checked = checkbox.is(':checked')
    //     if ( checked ) {
    //         checkbox.parent().addClass('selected')
    //     } else {
    //         checkbox.parent().removeClass('selected')
    //     }
    // })
    // $('#Current_Password').val('')
    $('.form-labeled-checkbox').click(function(e) {
        const checkbox = $(this).find('input.form-checkbox').first()
        const inputField = $(this).find('input.form-other-checkbox-value').first()
        // console.log("clicked", e)
        // console.log("is ", e.target === inputField[0] )
        if ( e.target !== inputField[0] ) {
            const checked = checkbox.is(':checked')
            const isActualCheckbox = $(e.target).hasClass('form-checkbox') || $(e.target).hasClass('form-checkbox-label')
            if ( checked ) {
                if ( isActualCheckbox ) {
                    checkbox.parent().addClass('selected')
                    checkbox.prop('checked', true)
                } else {
                    checkbox.prop('checked', false)
                    checkbox.parent().removeClass('selected')

                }

            } else {
                if ( isActualCheckbox ) {
                    checkbox.prop('checked', false)
                    checkbox.parent().removeClass('selected')
                } else {
                    checkbox.prop('checked', true)
                    checkbox.parent().addClass('selected')
                }
            }
            checkbox.trigger('change')
        }
    })

    const successModal = $('#success-modal');
    const successModalCloseButton = successModal.find('.btn-close')
    successModalCloseButton.click(() => {
        successModal.modal('hide')
    })
    const description = successModal.find('.description').html()
    if ( description !== "" ) {
        successModal.modal('show')
    }
    const settingsModal = $('#settings-modal');
    const settingsModalCloseButton = settingsModal.find('.btn-close')
    settingsModalCloseButton.click(() => {
        settingsModal.modal('hide')
    })
    const settingsErrors = settingsModal.find('.errors')
    const settingsAlerts = settingsModal.find('.alert')
    if ( (settingsErrors && settingsErrors.length) || (settingsAlerts && settingsAlerts.length) ) {
        settingsModal.modal('show')
    }

    const editPatientModal = $('#edit-patient-modal');
    const editPatientModalCloseButton = editPatientModal.find('.btn-close')
    editPatientModalCloseButton.click(() => {
        editPatientModal.modal('hide')
    })
    const editPatientErrors = editPatientModal.find('.errors')
    const editPatientAlerts = editPatientModal.find('.alert.alert-danger')
    if ( (editPatientErrors && editPatientErrors.length) || (editPatientAlerts && editPatientAlerts.length) ) {
        editPatientModal.modal('show')
    }
    const viewPoliciesModal = $('#view-policies-modal');
    const viewPoliciesModalCloseButton = viewPoliciesModal.find('.btn-close')
    viewPoliciesModalCloseButton.click(() => {
        viewPoliciesModal.modal('hide')
    })
    const skipInformationModal = $('#skip-information-modal');
    const skipInformationModalCloseButton = skipInformationModal.find('.btn-close')
    skipInformationModalCloseButton.click(() => {
        skipInformationModal.modal('hide')
    })
    const test = $('#test')
    test.click(() => {
        viewPoliciesModal.modal('show')
    })
    $('.js-settings').click(function()  {
        $('#settings-modal').modal('show')
    })

    $('.js-edit-patient').click(function()  {
        $('#edit-patient-modal').modal('show')
    })
    $('.js-view-policies').click(function()  {
        $('#view-policies-modal').modal('show')
    });
    $('#js-skip-information').click(function()  {
        $('#skip-information-modal').modal('show')
    });
    // $('.js-new-appointment').click(function()  {
    //     const appointmentModal = $('#new-appointment-modal');
    //
    //     appointmentModal.modal({backdrop: 'static', keyboard: false})
    //     appointmentModal.modal('show');
    // });
    $('.success-modal-content').click(function() {
        $('#success-modal').modal('hide')
    });

    $('.toggle-password').click(function() {
        let input = $(this).parent().find('input.iconned')
        if (input.prop('type') === "password") {
            input.prop('type', 'text')
        } else {
            input.prop('type', 'password')
        }
    })

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    $('#timezone').val(timezone)

    const dashboardForm = $('.dashboard-form form');
    const dashboardInputs = dashboardForm.find('input');

    const getCurrentDashboardInputState = () => {
        let dashboardInputsState = {}
        dashboardInputs.each((index, input) => {
            let inputObj = $(input)
            if ( inputObj.attr('name')) {
                if ( inputObj.is(':checkbox') ) {
                    dashboardInputsState[inputObj.attr('name')] = inputObj.prop('checked');
                } else {
                    dashboardInputsState[inputObj.attr('name')] = inputObj.val()
                }

            }
        })
        return dashboardInputsState
    }
    const initialDashboardInputsState = getCurrentDashboardInputState();

    dashboardInputs.on('change', () => {
        const currentDashboardInputsState = getCurrentDashboardInputState();
        let result = true
        Object.keys(currentDashboardInputsState).forEach((fieldName, index) => {
            if (currentDashboardInputsState[fieldName] !== initialDashboardInputsState[fieldName]) {
                result = false
            }
        })
        dashboardForm.find('button[type="submit"]').prop("disabled", result);
    })

    const patientModalForm = $('.edit-patient-modal form');
    const patientModalInputs = patientModalForm.find('input, select');

    const getPatientModalInputState = () => {
        let patientModalInputState = {}
        patientModalInputs.each((index, input) => {
            let inputObj = $(input)
            if ( inputObj.attr('name')) {
                if ( inputObj.is(':checkbox') ) {
                    patientModalInputState[inputObj.attr('name')] = inputObj.prop('checked');
                } else if (inputObj.is(':radio')) {
                    if (inputObj.prop('checked') === true) {
                        patientModalInputState[inputObj.attr('name')] = inputObj.val();
                    }
                } else {
                    patientModalInputState[inputObj.attr('name')] = inputObj.val()
                }
            }
        })
        return patientModalInputState
    }
    const initialPatientModalInputState = getPatientModalInputState();

    patientModalInputs.on('change', () => {
        const currentPatientModalInputState = getPatientModalInputState();
        let result = true
        Object.keys(currentPatientModalInputState).forEach((fieldName, index) => {
            if (currentPatientModalInputState[fieldName] !== initialPatientModalInputState[fieldName]) {
                result = false
            }
        })
        patientModalForm.find('button[type="submit"]').prop("disabled", result);
    })
    $('.js-dashboard-sidebar-accordion').click(() => {
        console.log('clicked')
       $('.sidebar.dashboard').toggleClass('collapsed');
    })

    const insuranceTabs = $('#insurance-tab')
    const tabContainer = insuranceTabs.closest('.tab-container')
    const primaryTabButton = insuranceTabs.find('#primary-tab')
    const secondaryTabButton = insuranceTabs.find('#secondary-tab')
    const primaryTab = tabContainer.find('#primary')
    const secondaryTab = tabContainer.find('#secondary')

    primaryTabButton.click(() => {
        secondaryTabButton.removeClass('show')
        secondaryTabButton.removeClass('active')
        primaryTabButton.addClass('show')
        primaryTabButton.addClass('active')
        secondaryTab.removeClass('show')
        secondaryTab.removeClass('active')
        primaryTab.addClass('show')
        primaryTab.addClass('active')
    })
    secondaryTabButton.click(() => {
        primaryTabButton.removeClass('show')
        primaryTabButton.removeClass('active')
        secondaryTabButton.addClass('show')
        secondaryTabButton.addClass('active')
        primaryTab.removeClass('show')
        primaryTab.removeClass('active')
        secondaryTab.addClass('show')
        secondaryTab.addClass('active')
    })

    const navbarDropdown = $('#navbarDropdown')
    const navItem = navbarDropdown.closest('li.nav-item.dropdown')
    const dropdownMenu = navItem.find('.dropdown-menu')
    navbarDropdown.click(() => {
        const ariaExpanded = navbarDropdown.attr('aria-expanded')
        if (ariaExpanded === "true" ) {
            navbarDropdown.attr('aria-expanded', "false")
        } else {
            navbarDropdown.attr('aria-expanded', "true")
        }
        navItem.toggleClass('show')
        dropdownMenu.toggleClass('show')
    })

    const navToggler = $('.navbar-toggler')
    navToggler.click(() => {
        const ariaExpanded = navToggler.attr('aria-expanded')
        if (ariaExpanded === "true" ) {
            navToggler.attr('aria-expanded', "false")
        } else {
            navToggler.attr('aria-expanded', "true")
        }
        navToggler.toggleClass('collapsed')
        $('#navbarSupportedContent').toggleClass('show')
    })

    const showMoreButton = $('.js-show-more')

    showMoreButton.on('click', (event) => {
        const clickedButton = event.target
        const parent = $(clickedButton).parent()
        if (clickedButton.textContent === "Show more" ) {
            parent.find('.js-optional').removeClass('hidden')
            clickedButton.textContent = "Show less"
        } else {
            parent.find('.js-optional').addClass('hidden')
            clickedButton.textContent = "Show more"
        }
    })
    const showDetailsButton = $('#js-show-details')
    showDetailsButton.click(() => {
        const clickedButton = showDetailsButton[0]
        if (clickedButton.textContent === "Show details" ) {
            $('.dashboard-form.dashboard').removeClass('hidden')
            $('.dashboard-logo-container').addClass('hidden')
            clickedButton.textContent = "Hide details"
        } else {
            $('.dashboard-logo-container').removeClass('hidden')
            $('.dashboard-form.dashboard').addClass('hidden')
            clickedButton.textContent = "Show details"
        }
    })

})
